/**
 * @description 过滤器
 */

let filtersList = {
    /**
     * @description  字体省略
     */
    ellipsis: function(value, position = 10) {
        if (!value) return;
        value = value.toString();
        return value.length < position
            ? value
            : value.substring(0, position) + "...";
    },
    roundFloatPrice: function(value = 0, digit = 2) {
        let result =
            Math.round(value * Math.pow(10, digit)) / Math.pow(10, digit);
        let min_price = 0.01;
        return result < min_price ? min_price : result;
    },
    encryptionPhone: function(value) {
        if (typeof value === "string") {
            return value.replace(/(\d{3})\d*(\d{4})/, "$1****$2");
        }
        return "";
    },
};

export default (vue) => {
    if (!vue.filter) return;
    for (let attr in filtersList) {
        vue.filter(`${attr}`, filtersList[`${attr}`]);
    }
};
